module.exports = __webpack_public_path__ + "img/PressCenter.9b6f3cbd.png";